export const SERIES_TITLES = [
  "Sara and the Pooka",
  "Alice in Wonderland",
  "Peter Pan",
] as const;

interface BookMetadata {
  reading_id: string;
  title: string;
}

function findBookSeriesPrefix(
  title: string,
  seriesPrefixes: readonly string[],
): string | undefined {
  for (const prefix of seriesPrefixes) {
    if (title.startsWith(prefix)) {
      return prefix;
    }
  }
  return undefined;
}

// `books` order is the reading order within a series.
export function filterBySeries<T extends BookMetadata>(
  books: T[],
  seriesTitles: readonly string[],
  completedReadingIds: Set<string>,
  inProgressReadingIds = new Set<string>(),
): T[] {
  if (seriesTitles.length === 0) {
    return books.filter((book) => !completedReadingIds.has(book.reading_id));
  }

  const seriesWithInProgress = new Set<string>();
  for (const book of books) {
    if (inProgressReadingIds.has(book.reading_id)) {
      const matchedSeries = findBookSeriesPrefix(book.title, seriesTitles);
      if (matchedSeries) {
        seriesWithInProgress.add(matchedSeries);
      }
    }
  }

  const seriesIncluded = new Set<string>();
  const result: T[] = [];

  for (const book of books) {
    const matchedSeries = findBookSeriesPrefix(book.title, seriesTitles);

    if (!matchedSeries) {
      if (!completedReadingIds.has(book.reading_id)) {
        result.push(book);
      }
      continue;
    }

    if (seriesWithInProgress.has(matchedSeries)) {
      continue;
    }

    if (seriesIncluded.has(matchedSeries)) {
      continue;
    }

    if (completedReadingIds.has(book.reading_id)) {
      continue;
    }

    seriesIncluded.add(matchedSeries);
    result.push(book);
  }

  return result;
}
